<script setup lang="ts">
import { TextProps } from "@/cms/primitives/Text/Text.types.ts";
import { computed } from "vue";

const props = withDefaults(defineProps<TextProps>(), {
  as: "p",
  variant: "body",
  color: "default",
});

const classes = computed(() => {
  /*
  Here we map Tailwind classes to the variants
   */
  const variants = {
    display1: "text-5xl",
    display2: "text-4xl",
    title1: "text-3xl",
    title2: "text-2xl",
    title3: "text-xl",
    title4: "text-lg",
    "body-large": "text-base",
    body: "text-small",
    "body-small": "text-xs",
  };

  /*
  Here we map Tailwind classes to the colors
   */
  const colors = {
    error: "text-red-600",
    light: "text-muted-foreground",
    default: "",
  };
  return [variants[props.variant], colors[props.color]];
});
</script>

<template>
  <component :is="as" :class="classes">
    <slot></slot>
  </component>
</template>
